import { APICore } from './apiCore'

const api = new APICore()

function getConfiguration (owner) {
  const baseUrl = `/configuration/${owner}`
  return api.get(baseUrl, {})
}

function updateConfiguration (params) {
  const baseUrl = '/configuration'
  return api.update(baseUrl, params)
}

export { getConfiguration, updateConfiguration }
